module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('revenue-and-costs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'revenueAndCosts'),
      expression: "selectedItem === 'revenueAndCosts'"
    }]
  }), _vm._v(" "), _c('ebitda', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'ebitda'),
      expression: "selectedItem === 'ebitda'"
    }]
  }), _vm._v(" "), (_vm.selectedItem === 'compare') ? _c('compare') : _vm._e(), _vm._v(" "), _c('potential', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'potential'),
      expression: "selectedItem === 'potential'"
    }]
  }), _vm._v(" "), _c('keyFigures', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'keyFigures'),
      expression: "selectedItem === 'keyFigures'"
    }]
  }), _vm._v(" "), _c('materials', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'materials'),
      expression: "selectedItem === 'materials'"
    }]
  }), _vm._v(" "), _c('all-invoices', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'allInvoices'),
      expression: "selectedItem === 'allInvoices'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('allInvoices', $event)
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d55ee438", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d55ee438"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning.vue
// module id = 884
// module chunks = 0